<template>
  <div>
    <h1 class="mt-4">{{ $t("resetPassword") }}</h1>
    <p class="mt-4 text-center">
      <strong>{{ $t("passwordReset") }}</strong>
    </p>
    <b-col lg="6" class="mt-4 mx-auto">
      <p v-if="error" class="error">{{ error }}</p>
      <div class="form-group row">
        <label for="password">{{ $t("password") }}</label>
        <input
          v-model.lazy="$v.user.new_password1.$model"
          type="password"
          id="password"
          class="form-control"
          required
        />
        <error-list :field="$v.user.new_password1"></error-list>
      </div>
      <div class="form-group row">
        <label for="password">{{ $t("confirmPassword") }}</label>
        <input
          v-model.lazy="$v.user.new_password2.$model"
          type="password"
          id="passwordConfirmation"
          class="form-control"
          @keyup.enter="changePassword()"
        />
        <error-list :field="$v.user.new_password1"></error-list>
      </div>
      <div class="form-group row text-center">
        <b-button
          class="text-center mt-3 mb-3"
          variant="outline-secondary"
          :spinner="loading"
          :disabled="$v.user.$invalid"
          @click="changePassword()"
        >
          <span class="mt-5 mb-3">{{ $t("userManagement.changePassword") }}</span>
        </b-button>
      </div>
    </b-col>
  </div>
</template>

<script>
import { minLength, required, sameAs } from "vuelidate/lib/validators";
import AuthService from "@/services/AuthService";

export default {
  name: "passwordResetConfirm",
  data() {
    return {
      user: {
        new_password1: null,
        new_password2: null
      },
      uid: this.uid,
      token: this.token,
      error: null,
      loading: false
    };
  },
  validations: {
    user: {
      new_password1: {
        required,
        minLength: minLength(8)
      },
      new_password2: {
        sameAsPassword: sameAs("new_password1")
      }
    }
  },
  mounted() {
    this.getParams();
  },
  methods: {
    getParams() {
      this.uid = this.$route.params.uid;
      this.token = this.$route.params.token;
    },
    changePassword() {
      this.loading++;
      AuthService.resetPasswordConfirm(this.user.new_password1, this.user.new_password2, this.uid, this.token)
        .then((response) => {
          if (response.status === 200) {
            this.error = null;
            this.$router.push("/password-reset-complete");
            this.$bvToast.toast(this.$t("passwordSaved"), {
              title: this.$t("password"),
              variant: "success"
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status === 400) {
              this.error = this.$t("errors.generic");
            } else {
              this.error = this.$t("errors.generic");
            }
          } else {
            this.error = this.$t("errors.generic");
          }
        })
        .finally(() => (this.loading = false));
    }
  }
};
</script>
s
<style scoped lang="scss">
form {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: 50px auto auto auto;
}

.error {
  color: red;
}
</style>
